import { jsxs } from "react/jsx-runtime";
import React, { forwardRef } from "react";
import { string, bool, node, arrayOf, oneOf, oneOfType, func, element } from "prop-types";
import cx from "classnames";
const propTypes = {
  ariaControls: string,
  button: bool,
  children: oneOfType([arrayOf(node), node]),
  className: string,
  colour: oneOf(["", "black", "grey", "white"]),
  disabled: bool,
  newWindow: bool,
  onClick: func,
  prefix: string,
  text: oneOfType([string, element]),
  url: string,
  subtle: bool
};
const Hyperlink = forwardRef((props, ref) => {
  const {
    prefix = "",
    children,
    text,
    url = "#",
    subtle,
    disabled = false,
    button = false,
    colour,
    className,
    onClick,
    newWindow = false,
    ariaControls,
    ...otherProps
  } = props;
  function preventClick(e) {
    e.preventDefault();
  }
  const cssStyles = cx(
    className,
    `${prefix}link`,
    colour && `${prefix}link--${colour}`,
    subtle && `${prefix}link--subtle`,
    disabled && `${prefix}link--disabled`
  );
  let role = button ? "button" : null;
  role = disabled ? "link" : role;
  return /* @__PURE__ */ jsxs(
    "a",
    {
      ref,
      target: newWindow ? "_blank" : null,
      ...otherProps,
      href: !disabled ? url : null,
      className: cssStyles,
      role,
      "aria-disabled": disabled && `${disabled}`,
      "aria-controls": ariaControls ? ariaControls : null,
      onClick: button && disabled ? preventClick : onClick,
      children: [
        text && text.length > 0 ? text : "",
        text && children ? " " : null,
        children
      ]
    }
  );
});
Hyperlink.propTypes = propTypes;
Hyperlink.displayName = "Hyperlink";
var Hyperlink_default = Hyperlink;
export {
  Hyperlink_default as default
};
